import React from 'react'
import PropTypes from 'prop-types'

import AnimatedScrollBox from 'Components/Blocks/_Legacy/AnimatedScrollBox'

import { Container, ImageHolder } from './styles'

import { SEQUENCES } from '../../../sequences.js'

function ImageBlock({ index }) {
  return (
    <Container>
      <ImageHolder>
        <AnimatedScrollBox sequence={SEQUENCES.steps[index]} />
      </ImageHolder>
    </Container>
  )
}

ImageBlock.defaultProps = {}

ImageBlock.propTypes = {
  index: PropTypes.number.isRequired,
}

export default ImageBlock
